import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowLeft } from 'lucide-react';

const MarketHero = ({ badge, headline, intro, ctaLabel }) => (
  <section className="relative py-20 bg-gradient-to-br from-slate-50 via-white to-emerald-50 overflow-hidden">
    <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-100 rounded-full blur-3xl opacity-40" />
    <div className="absolute bottom-10 right-10 w-96 h-96 bg-amber-100 rounded-full blur-3xl opacity-30" />
    <div className="container mx-auto px-6 relative z-10">
      <Link
        to="/"
        data-testid="market-back-home"
        className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-emerald-600 mb-6"
      >
        <ArrowLeft className="w-4 h-4" /> Back to all markets
      </Link>
      <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4">
        <MapPin className="w-4 h-4" /> {badge}
      </div>
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-4 max-w-4xl leading-tight">
        {headline}
      </h1>
      <p className="text-lg md:text-xl text-slate-700 max-w-3xl leading-relaxed">{intro}</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <a
          href="#forms"
          data-testid="market-cta-seller"
          className="px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-semibold transition-colors"
        >
          Get My {ctaLabel} Cash Offer
        </a>
        <a
          href="#forms"
          data-testid="market-cta-buyer"
          className="px-6 py-3 bg-white border-2 border-emerald-600 text-emerald-700 hover:bg-emerald-50 rounded-lg font-semibold transition-colors"
        >
          Join {ctaLabel} Buyer List
        </a>
      </div>
    </div>
  </section>
);

export default MarketHero;
